"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareCartCms = void 0;
var ShareCartCms = /** @class */ (function () {
    function ShareCartCms() {
        this.shareLinkLabel = 'Share';
        this.shareCartModalHeading = 'Share your cart';
        this.descriptionLine1 = 'Share all the great stuff you picked with your family or friends';
        this.smbDescriptionLine1 = 'Share all the great items you’ve selected with your business partner or teammates.';
        this.descriptionLine2 = '<b>Heads up:</b> We won\'t include any of your personalized pricing or down payment info when you share your cart.';
        this.emailCTALabel = 'Email';
        this.textCTALabel = 'Text';
        this.copyLinkCTALabel = 'Copy link';
        this.linkCopiedText = 'Link copied';
        this.shareCartModalFooter = 'Cart will be available for 60 days. Promo offers, pricing, and availabity of items are subject to change by the time your cart is retrieved';
        this.sharedCartHeader = 'Take a look at my AT&T cart';
        this.sharedCartDescription1 = 'Hey, check out the cool stuff that I added to my AT&T cart.';
        this.smbsharedCartDescription1 = 'Hi, \r I’d like you to take a look at the items I’ve added to my AT&T cart.';
        this.smbsharedCartFooter1 = 'This cart will be saved for 60 days but the availability, pricing and promotion eligibility for';
        this.smbsharedCartFooter = this.smbsharedCartFooter1 + " the items in the cart may change anytime without notice.";
    }
    return ShareCartCms;
}());
exports.ShareCartCms = ShareCartCms;
//# sourceMappingURL=ShareCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/ShareCart/ShareCart.cms.js
// module id = 568
// module chunks = 8